module.exports = __webpack_public_path__ + "static/img/patient.e0712e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/patient.png
// module id = /fxZ
// module chunks = 7